import { render, staticRenderFns } from "./SoundOffIcon.vue?vue&type=template&id=ec5d95d4&"
import script from "./SoundOffIcon.vue?vue&type=script&lang=js&"
export * from "./SoundOffIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports